export const candidateRequestStepIds = {
  profile: 'profile',
  screening: 'screening',
  contract: 'contract',
  payment: 'payment',
} as const;

export type CandidateRequestStepId =
  typeof candidateRequestStepIds[keyof typeof candidateRequestStepIds];
